import React from "react";
import FieldLogs from "../FieldLogs/FieldLogs";
import Header from "../../../../UI-Components/Header/header";
import InsideTransactionHeader from "../InsideTransactionHeader";

const PoolLogs = () => {
  return (
    <>
      <Header pageTitle="Logs Management" />
      <div className="content heightfull cont">
        <div className="content-left-panel" style={{ width: "25rem" }}>
          <InsideTransactionHeader selectionType="poolLogs" />
        </div>
        <FieldLogs logType="POOL_CONFIG" />
      </div>
    </>
  );
};

export default PoolLogs;
